import { IHisInformationRepository, HisInformation, HisInformationSetting } from "../../../domain/his";
import { AuthenticatedService } from "../../../infrastructure";
import { HisInformationTranslator } from "./HisInformationTranslator";

export class HisInformationRepository extends AuthenticatedService implements IHisInformationRepository {
  constructor(getToken: () => string) {
    super(getToken);
  }

  async getDocumentRelatedHisInformation(documentId: number): Promise<HisInformation> {
    if (!documentId) {
      throw new Error("documentIdが有効な数値ではありません.");
    }
    const url = "/api/document/" + documentId + "/his-information";
    const query = { params: { token: this.token } };
    const result = await this.get(url, query);
    const translator = new HisInformationTranslator();
    return translator.toHisInformation(result.data);
  }

  async getLatestHisInformation(patientId: string, institutionNo: string, regionalInstitutionNo: string, hisInfoGetterParameter: string, systemKey: string, linkKey: string): Promise<HisInformation> {
    if (!patientId) {
      throw new Error("patientIdが有効な文字列ではありません.");
    }
    const url = "/api/patient/" + patientId + "/his-information";
    const query = {
      params: {
        token: this.token,
        institutionNo: !!institutionNo ? institutionNo : "",
        regionalInstitutionNo: !!regionalInstitutionNo ? regionalInstitutionNo : "",
        hisInfoGetterParameter: !!hisInfoGetterParameter ? hisInfoGetterParameter : "",
        systemKey: !!systemKey ? systemKey : "",
        linkKey: !!linkKey ? linkKey : "",
      }
    };
    const result = await this.get(url, query);
    const translator = new HisInformationTranslator();
    return translator.toHisInformation(result.data);
  }

  async getHisInformation(patientId: string, institutionNo: string, regionalInstitutionNo: string, hisInfoGetterParameter: string, systemKey: string, linkKey: string): Promise<HisInformation> {
    if (!patientId) {
      throw new Error("patientIdが有効な文字列ではありません.");
    }
    const url = "/api/patient/" + patientId + "/his-information";
    // TODO: refactor
    const query = {
      params: {
        token: this.token,
        institutionNo: (institutionNo != null && institutionNo !== undefined) ? institutionNo : "",
        regionalInstitutionNo: (regionalInstitutionNo !== null && regionalInstitutionNo !== undefined) ? regionalInstitutionNo : "",
        hisInfoGetterParameter: (hisInfoGetterParameter !== null && hisInfoGetterParameter !== undefined) ? hisInfoGetterParameter : "",
        systemKey: (systemKey !== null && systemKey !== undefined) ? systemKey : "",
        linkKey: (linkKey !== null && linkKey !== undefined) ? linkKey : "",
      }
    };
    const result = await this.get(url, query);
    const translator = new HisInformationTranslator();
    return translator.toHisInformation(result.data);
  }

  async getHisInformationSettings(): Promise<HisInformationSetting[]> {
    const url = "/api/format/his-information";
    const result = await this.get(url);
    const translator = new HisInformationTranslator();
    return translator.toHisInformationSettings(result.data);
  }
}
